<script>
	import { Button } from '$lib/shadcn/ui/button'
	import * as DropdownMenu from '$lib/shadcn/ui/dropdown-menu'
	import Logo from '$lib/svg/Logo.svelte'

	export let data
</script>

<header class="fixed top-0 w-full z-10 bg-background">
	<nav
		class="relative flex justify-end sm:justify-between items-center h-16 px-8"
	>
		<a
			href="/"
			class="absolute -translate-x-1/2 left-1/2 h-7 mt-2 text-foreground"
		>
			<Logo />
		</a>
		<div class="hidden sm:block">
			<Button href="/scenes" variant="ghost">Browse</Button>
		</div>
		<div class="hidden sm:block">
			{#if data.session}
				{@const username = data.session?.user.user_metadata.username}
				<Button
					href="/logout"
					variant="ghost"
					data-sveltekit-preload-data="off">Logout</Button
				>
				<Button href="/@{username.toLowerCase()}">Profile</Button>
			{:else}
				<Button href="/login" variant="ghost">Login</Button>
				<Button href="/join">Join</Button>
			{/if}
		</div>
		<div class="block sm:hidden">
			<DropdownMenu.Root>
				<DropdownMenu.Trigger
					><svg
						width="15"
						height="15"
						viewBox="0 0 15 15"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						><path
							d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z"
							fill="currentColor"
							fill-rule="evenodd"
							clip-rule="evenodd"
						/></svg
					></DropdownMenu.Trigger
				>
				<DropdownMenu.Content>
					<DropdownMenu.Group>
						{#if data.session}
							{@const username =
								data.session?.user.user_metadata.username}
							<DropdownMenu.Item
								><Button
									href="/@{username.toLowerCase()}"
									class="w-full">Profile</Button
								></DropdownMenu.Item
							>
							<DropdownMenu.Item>
								<Button
									href="/logout"
									variant="ghost"
									class="w-full">Logout</Button
								>
							</DropdownMenu.Item>
						{:else}
							<DropdownMenu.Item
								><Button href="/join" class="w-full"
									>Join</Button
								></DropdownMenu.Item
							>
							<DropdownMenu.Item
								><Button
									href="/login"
									variant="ghost"
									class="w-full">Login</Button
								></DropdownMenu.Item
							>
						{/if}
						<DropdownMenu.Item>
							<Button
								href="/scenes"
								variant="ghost"
								class="w-full">Browse</Button
							></DropdownMenu.Item
						>
					</DropdownMenu.Group>
				</DropdownMenu.Content>
			</DropdownMenu.Root>
		</div>
	</nav>
</header>
